import React from 'react';
import {View, Text, TouchableOpacity} from 'react-native';
import useWindowDimensionsSafe from 'src/Modules/Native/useWindowDimensionsSafe';

import AppIntroSlider from 'react-native-app-intro-slider';
import {SafeAreaView} from 'react-native-safe-area-context';

import FastImage from 'src/Utils/FastImage';
import {navigationRef} from 'src/Nav/navigationHelpers';
import {cloudFlareOptimizeImage} from '../Utils/helpers';
import {loginAdminTestUser} from '../Utils/deepLinkHelper';

const scavengerSlides = [
  {
    key: '1',
    title: 'EXPLORE THE WORLD',
    titleStyle: {
      fontFamily: 'Alternate Gothic No3 D',
      color: 'white',
      fontSize: 40,
    },
    // explorers in front of globe
    image: {
      uri: cloudFlareOptimizeImage(
        'https://photos.letsroam.com/photos_other/scavenger-hunt-location-1648583369_original.png',
      ),
    },
    imageStyle: {height: 430, width: 320, resizeMode: 'contain'},
    backgroundColor: global?.color?.orange,
  },
  {
    key: '2',
    title: 'BY SOLVING CHALLENGES',
    titleStyle: {
      fontFamily: 'Alternate Gothic No3 D',
      color: 'white',
      fontSize: 30,
    },
    // lots of user pictures image
    image: {
      uri: cloudFlareOptimizeImage(
        'https://photos.letsroam.com/photos_other/scavenger-hunt-location-1648583386_original.png',
        600,
        20,
      ),
    },
    imageStyle: {height: 430, width: 320, resizeMode: 'contain'},
    backgroundColor: global?.color?.blue,
  },
  {
    key: '3',
    title: 'WITH YOUR FRIENDS',
    titleStyle: {
      fontFamily: 'Alternate Gothic No3 D',
      color: 'white',
      fontSize: 40,
    },
    // all characters image
    image: {
      uri: cloudFlareOptimizeImage(
        'https://photos.letsroam.com/photos_other/scavenger-hunt-location-1648583409_original.png',
      ),
    },
    imageStyle: {height: 450, width: 300},
    backgroundColor: global?.color?.gray1,
  },
  {
    key: '4',
    title: 'ANYTIME, ANYWHERE',
    titleStyle: {
      fontFamily: 'Alternate Gothic No3 D',
      color: 'white',
      fontSize: 40,
    },
    // markers on globe
    image: {
      uri: cloudFlareOptimizeImage(
        'https://photos.letsroam.com/photos_other/scavenger-hunt-location-1648583434_original.png',
      ),
    },
    imageStyle: {height: 430, width: 300},
    backgroundColor: global?.color?.yellow,
  },
  {
    key: '5',
    title: 'FOR ANY OCCASION',
    titleStyle: {
      fontFamily: 'Alternate Gothic No3 D',
      color: 'white',
      fontSize: 40,
    },
    // characters in different outfits
    image: {
      uri: cloudFlareOptimizeImage(
        'https://photos.letsroam.com/photos_other/scavenger-hunt-location-1648583462_original.png',
      ),
    },
    imageStyle: {height: 420, width: 300},
    backgroundColor: global?.color?.teal,
  },
];

const AppIntroSwiper = () => {
  const {height} = useWindowDimensionsSafe();

  const _onDone = async () => {
    navigationRef.navigate('LoginPage');
  };

  const _renderItem = ({item}) => {
    // console.log({item});
    return (
      <View
        style={{
          flex: 1,
          backgroundColor: item.backgroundColor,
          alignItems: 'center',
          paddingTop: 60,
          minHeight: height,
        }}>
        <SafeAreaView>
          <Text style={item.titleStyle}>{item.title}</Text>
          <FastImage
            source={item.image}
            style={item.imageStyle}
            resizeMode={'contain'}
          />
          <Text style={{}}>{item.text}</Text>
        </SafeAreaView>
      </View>
    );
  };

  return (
    <View style={{flex: 1, position: 'relative'}}>
      <AppIntroSlider
        data={scavengerSlides}
        renderItem={_renderItem}
        onDone={_onDone}
      />
      <TouchableOpacity
        style={{
          height: 20,
          position: 'absolute',
          zIndex: 60,
          top: 60,
          right: 0,
          width: 20,
          marginTop: 10,
          backgroundColor: __DEV__ ? 'red' : 'transparent',
        }}
        onPress={() => {
          console.log('loginAdminTestUser clicked');
          loginAdminTestUser();
        }}
        testID={'loginAdminTestUser'}></TouchableOpacity>
    </View>
  );
};

export default AppIntroSwiper;
